/* eslint-disable no-unused-vars */
import { useDispatch } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { BrandContent, useTailwindBrand } from "../../Components/shared";
import { SET_COURSE_DECLARATION_INFO } from "../../Redux/Reducers/DeclarationCourseReducers";
import ButtonField from "../../Components/Ui/ButtonField";

interface Props {
  title: string | any;
  body: any;
  handleChangeStep?: ((value: number) => void) | any;
  handleNexStep?: ((value: number) => void) | any;
  value?: number;
  step: number;
  load?: boolean;
  isHere?: boolean;
  disabled?: boolean;
  foot?: any;
  generalStep?: any;
  icon?: any;
}

const IndexStep = (props: Props) => {
  const dispatch = useDispatch();
  const { classes, common } = useTailwindBrand();

  const handleBackStep = () => {
    if (props.generalStep) {
      dispatch({
        type: SET_COURSE_DECLARATION_INFO,
        payload: {
          ...props.generalStep,
          step: props.step - 1,
          firstStep: props.generalStep?.firstStep ?? null,
          secondStep: props.generalStep?.secondStep ?? null,
          thirdStep: props.generalStep?.thirdStep ?? null,
          firstCourse: props.generalStep?.firstCourse ?? null,
          cours: props.generalStep?.cours ?? null,
          punctualCourse: props.generalStep?.punctualCourse ?? null,
        },
      });
    }
    props.handleChangeStep(props.step - 1);
  };

  return (
    <div className="space-y-4 w-full h-full relative lg:px-4 p-2 ">
      <BrandContent
        tag="h2"
        children={props.title}
        type="homeSubtitle"
        className={`${common.subtitle2} mb-6 ${classes.primaryText}`}
      />
      <BrandContent
        tag="div"
        children={props.body}
        type="description"
        className={`${common.body} mb-6`}
      />
      {props.foot}
      {!props.isHere && (
        <div className="flex lg:flex-row flex-col-reverse gap-3 px-2 py-4 justify-between mx-auto w-full border-t border-gray-100">
          <ButtonField
            variant="outlined"
            onClick={() => handleBackStep()}
            label="Précédent"
            startIcon={<ArrowBackIcon />}
          />
          <ButtonField
            variant="contained"
            disabled={props.disabled}
            loading={props.load}
            onClick={() => props.handleNexStep(props.value)}
            label={props.value === 5 ? (props.load ? "Déclaration..." : "Déclarer") : "Suivant"}
            endIcon={props.value !== 5 ? <ArrowForwardIcon /> : <CheckCircleOutlineIcon />}
          />
        </div>
      )}
    </div>
  );
};

export default IndexStep;
